<template>
  <v-card class="rounded-lg white">
    <v-card-title style="font-size: small" class="success--text">
      <v-img class="ml-2" max-height="15" max-width="15" src="/img/icons/factor.svg"></v-img>
      {{ title }}
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <m-datatable :show-filter-row="false" show-select="false"
                   :headers="headers" :export-url="printUrl" :apiUrl="url" :filters.sync="filters" ref="datatable">
        <template v-slot:item.created_at="{ item }">
          {{ format_date(item.datetime) }}
        </template>
        <template v-slot:item.time="{ item }">
          {{ format_time(item.datetime) }}
        </template>
      </m-datatable>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment-jalaali";

export default {
  name: "UserTurnover",
  data() {
    return {
      printUrl: "subscriptions/userTurnover/all",
      filters: {},
    };
  },
  computed: {
    url() {
      return "subscriptions/userTurnover";
    },
    title() {
      return this.setDocumentTitle("گردش حساب کاربر");
    },
    headers() {
      let headers = [
        {
          text: "تاریخ",
          value: "created_at",
          type: "date",
        },
        {
          text: "ساعت",
          value: "time",
          filterable: false,
          sortable: false,
        },
        {
          text: "توضیحات",
          value: "explanation",
        },
        {
          text: "بدهکار",
          value: "bed",
          type: "numeric",
          filterable: false,
          sortable: false,
        },
        {
          text: "بستانکار",
          value: "bes",
          type: "numeric",
          filterable: false,
          sortable: false,
        },
        {
          text: "مانده",
          value: "remain",
          type: "numeric",
          filterable: false,
          sortable: false,
        },
        {
          text: "فاکتور",
          value: "factor",
        },
      ];

      return headers;
    },
  },
  methods: {
    format_date(value) {
      return moment(value).format("YYYY/MM/DD");
    },
    format_time(value) {
      return moment(value).format("HH:MM");
    },
  },
};
</script>

<style scoped lang="scss"></style>
